import React,{useEffect} from "react";
import {connect} from "react-redux";
import * as actions from "../../store/actions/index";
import FlexContainer from "../UI/FlexContainer/FlexContainer";
import Spinner from "../Spinner/Spinner"
import { string_to_slug as slug} from "../../store/utility";

const Collection = (props) => {

    useEffect(()=>{
        props.onFetchBrandsClient();  
    },[])
 
   if(props.loading){
       return <Spinner/>
   }
    return (
        <>
        
            <section id="temp">
                <div className="container p-4">
                    <FlexContainer>
 
                        {  
                            props.collection&&props.collection.map(collection=>(

                              
                                <div >
                                <a 
                                href={`/brand/${slug(collection.name)}/${collection.id}/${props.categoryType}`} 
                                // target="_blank"
                                    
                                    > <img   src={collection.imgUrl} style={{width:"100%",height:"120px"}}/></a>
                                   <div ><p>{collection.desc}</p></div> 
                                </div>
                            ))
                        }

                    </FlexContainer> 
                   
                </div>
            </section>
        </>
    ); 
}
const mapStateToProps = state=>{
    return{
        collection:state.brands.brands,
        loading:state.collection.loading,
        categoryType: state.categoryProducts.categoryType,
    }
}
const mapDisptachToProps  = dispatch=>{
    return{
        onFetchBrandsClient:()=>dispatch(actions.onFetchBrandsClient())
    }
}
export default connect(mapStateToProps,mapDisptachToProps)(Collection);

